import sluggo from 'sluggo'
class slug {
	get(title){
		var makeSlug = sluggo(title)
		return makeSlug
	}
}
export default new slug()


// WEBPACK FOOTER //
// ./src/data/slug.js